import { render, staticRenderFns } from "./QuestionDetails.vue?vue&type=template&id=75c62a9e&"
import script from "./QuestionDetails.vue?vue&type=script&lang=js&"
export * from "./QuestionDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetails.vue?vue&type=style&index=0&id=75c62a9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports